import { render, staticRenderFns } from "./tempcarbill.vue?vue&type=template&id=98e67c9c&"
import script from "./tempcarbill.vue?vue&type=script&lang=js&"
export * from "./tempcarbill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports